import { useContext } from 'react'
import {
  FinderDispatchContext,
  FinderStateContext
} from '../contexts/FinderContext'

export const useFinderState = () => {
  const context = useContext(FinderStateContext)

  if (!context)
    throw new Error('useFinderState must be used within a FinderStateProvider')

  return context
}

export const useFinderDispatch = () => {
  const context = useContext(FinderDispatchContext)

  if (!context)
    throw new Error(
      'useFinderDispatch must be used within a FinderDispatchProvider'
    )

  return context
}

export const useFinder = () => {
  return [useFinderState(), useFinderDispatch()]
}

export default useFinder
